import RequiresAuth from '@website/components/auth/RequiresAuth';
import BroadcastMessageToGroup from '@website/components/hosts/dashboard/groupBookings/BroadcastMessageToGroup';
import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';

export default function Message() {
  const router = useRouter();
  const { groupID, hostURL } = router.query;

  return (
    <>
      <RequiresAuth>
        <Container className="pt-4 mt-4">
          <BroadcastMessageToGroup
            groupID={groupID as string}
            hostURL={hostURL as string}
          />
        </Container>
      </RequiresAuth>
    </>
  );
}
